export enum FloorGameWebGLVariant {
    TierUp = 'floor-game-up',
    TierDown = 'floor-game-down',
    OnFire = 'fire-background',
}
